import { BoardId, MarketId } from "./common"

export enum OrderType {market = 'market', limit = 'limit', unknown = 'unknown'}
export enum OrderSide {buy = 'buy', sell = 'sell'}
export enum PositionSide {both = 'both', long = 'long', short = 'short'}

export interface Instrument {
  market: MarketId
  board: BoardId
  symbol: string
  baseCoin: string
  quoteCoin: string
  minNotionalValue?: number | string
  priceStep?: number | string
  quantityStep?: number | string
  lotSize: number
  isTrading: boolean
}

export interface Order {
  createdTimestamp: number
  updateTimestamp: number
  type: OrderType
  status: string
  market: MarketId
  board: BoardId
  symbol: string
  price: number | string
  quantity: number | string
  volume: number | string
  remainingQuantity: number | string
  remainingVolume: number | string
  side: OrderSide
  positionSide: PositionSide
  orderId: number | string
  clientOrderId: string
  isStop?: boolean
  isClosePosition?: boolean
}

export interface Position {
  createdTimestamp: number
  updateTimestamp: number
  market: MarketId
  board: BoardId
  symbol: string
  entryPrice: number | string
  liquidationPrice: number | string | undefined
  size: number | string
  positionSide: PositionSide | undefined
  positionVolume: number | string
  unrealisedPnl: number | string
}

export interface Deal {
  timestamp: number
  market: MarketId
  board: BoardId
  symbol: string
  price: number | string
  quantity: number | string
  volume: number | string
  fee: number | string
  feeAsset?: string
  side: OrderSide
  dealId: number | string
  orderId: number | string
  clientOrderId: string
}

export interface Funding {
  timestamp: number
  market: MarketId
  board: BoardId
  symbol: string
  fee: number | string
}

export interface Ticker {
  market: MarketId
  board: BoardId
  symbol: string
  bidPrice: number | string
  askPrice: number | string
}

export interface CreateOrderParams {
  type: OrderType
  market: MarketId
  board: BoardId
  symbol: string
  side: OrderSide
  quantity: number | string
  price?: number | string
  closePosition?: true
  positionSide?: PositionSide
}

export interface CreateMarketOrderParams extends CreateOrderParams {
  type: OrderType.market
  price?: undefined
}

export interface CreateLimitOrderParams extends CreateOrderParams {
  type: OrderType.limit
  price: number | string
}

export interface CreateStopOrderParams extends Omit<CreateOrderParams, 'quantity'> {
  quantity?: number | string
  triggerPrice: number | string
}

export interface CreatePreOrderParams {
  market: MarketId
  board: BoardId
  symbol: string
  side: OrderSide
  price: number | string
}

export interface InstrumentFee {
  maker: number
  taker: number
}
